export default "__VITE_ASSET__s68r1Q5t__"